import Details from './Details';

export { Details };
